var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckblue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.0457,
    y: 0.2,
    width: 19.6,
    height: 19.6,
    stroke: "white",
    strokeWidth: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3919 3.43999L9.85082 19.272L1.62477 13.0218L1.62481 13.0217L1.62087 13.0189C0.977163 12.554 0.860761 11.6524 1.33667 10.9935C1.80113 10.3504 2.70143 10.2336 3.36022 10.7079L8.99645 14.9865L9.16583 15.1151L9.28379 14.9381L18.0086 1.85097C18.4462 1.19457 19.3491 0.987662 19.9886 1.44947L19.9885 1.44958L19.9947 1.45374C20.6511 1.89134 20.858 2.79432 20.3962 3.43374L20.3961 3.43365L20.3919 3.43999Z",
    fill: "#146C94",
    stroke: "white",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckblue);
export default __webpack_public_path__ + "static/media/checkblue.6ea35a6d0acc331f05dd4311d857e151.svg";
export { ForwardRef as ReactComponent };